/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostSaveDraftConfigurationMutationRequest, PostSaveDraftConfigurationMutationResponse, PostSaveDraftConfigurationPathParams, PostSaveDraftConfiguration401, PostSaveDraftConfiguration403 } from "../../models/PostSaveDraftConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostSaveDraftConfigurationUrl({ debtorCode }: { debtorCode: PostSaveDraftConfigurationPathParams["debtorCode"] }) {
  const res = { method: 'POST', url: `/api/v1/debtors/${debtorCode}/draft-configurations` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/draft-configurations}
 */
export async function postSaveDraftConfiguration({ debtorCode, data }: { debtorCode: PostSaveDraftConfigurationPathParams["debtorCode"]; data: PostSaveDraftConfigurationMutationRequest }, config: Partial<RequestConfig<PostSaveDraftConfigurationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostSaveDraftConfigurationMutationResponse, ResponseErrorConfig<PostSaveDraftConfiguration401 | PostSaveDraftConfiguration403>, PostSaveDraftConfigurationMutationRequest>({ method : "POST", url : getPostSaveDraftConfigurationUrl({ debtorCode }).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}